import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";
import { Label } from "@/components/ui/label";
import { useApi, fileUrl, errMsg } from "@/lib/api";

export const ImageUpload = ({ label, value, onChange, testId, wide }) => {
  const api = useApi();
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { path } = await api("post", "/me/upload", fd);
      onChange(path);
      toast.success("Immagine caricata");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      ref.current.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</Label>
      <div className={`relative flex items-center justify-center overflow-hidden rounded-xl border-2 border-dashed border-slate-200 bg-slate-50 ${wide ? "h-28" : "h-28 w-28"}`}>
        {value ? <img src={fileUrl(value)} alt="" className="h-full w-full object-cover" /> : null}
        <button type="button" onClick={() => ref.current.click()} data-testid={testId}
                className="absolute inset-0 flex items-center justify-center bg-slate-900/0 text-slate-500 transition-colors hover:bg-slate-900/40 hover:text-white">
          {busy ? <Loader2 className="animate-spin" /> : !value && <ImagePlus />}
        </button>
        {value && !busy && (
          <button type="button" onClick={() => onChange("")} data-testid={`${testId}-remove`} aria-label="Rimuovi"
                  className="absolute right-1.5 top-1.5 rounded-full bg-white p-1 text-slate-700 shadow"><X size={12} /></button>
        )}
      </div>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" data-testid={`${testId}-input`}
             onChange={(e) => upload(e.target.files[0])} />
    </div>
  );
};
